import {
    GetPermissionInfoStatus,
    RecipientPermissionInfo,
} from '../../schema/RecipientPermissionInfo';
import { SharingRecipientsInfo } from '../../schema/SharingRecipientsInfo';

export function hasGetRecipientPermissionFailed(
    sharingRecipientsInfo: SharingRecipientsInfo
): boolean {
    const allRecipients: RecipientPermissionInfo[] = sharingRecipientsInfo.recipientPermissionInfos;
    return allRecipients.some(
        info => info.getPermissionInfoStatus === GetPermissionInfoStatus.Failed
    );
}
